import {animate, keyframes, state, style, transition, trigger} from '@angular/animations';
import {ChangeDetectionStrategy, Component, inject} from '@angular/core';

import {Toast} from 'ngx-toastr';
import {AssistantAttachmentsService} from 'app/blocks/service/assistant-context/assistant-attachments.service';
import {ASSISTANT_LABEL} from 'app/layout/components/hauliermagic-assistant-chat/hauliermagic-assistant-label';

@Component({
    // Angular 22 defaults to OnPush; Eager preserves the previous behaviour.
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
    selector: '[toast-component]',
    templateUrl: './alert-toast.component.html',
    styleUrls: ['./alert-toast.component.scss'],
    animations: [
        trigger('flyInOut', [
            state('inactive', style({opacity: 0})),
            state('active', style({opacity: 1})),
            state('removed', style({opacity: 0})),
            transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
            transition('active => removed', animate('{{ easeTime }}ms {{ easing }}'))
        ])
    ],
    preserveWhitespaces: false
})
export class AlertToastComponent extends Toast {
    // ngx-toastr 20 injects toastrService/toastPackage in the base class and exposes
    // options/title/message/width as signals, so no constructor or re-declaration here.

    private assistantAsk = inject(AssistantAttachmentsService);

    readonly askLabel = ASSISTANT_LABEL;

    /** the ask link on error toasts while the assistant is enabled for the user (CU-14zefhy1qnh). */
    get canAskCopilot(): boolean {
        return this.assistantAsk.copilotEnabled && /\btoast-error\b/.test(this.toastPackage?.toastType || '');
    }

    askCopilot(event: Event) {
        event.stopPropagation();
        const text = [this.title(), this.message()]
            .filter(Boolean)
            .map((t) => String(t).replace(/<[^>]*>/g, ' '))
            .join(' - ');
        this.assistantAsk.askAboutError(text);
        this.remove();
        return false;
    }

    action(event: Event) {
        event.stopPropagation();
        this.toastPackage.triggerAction();
        return false;
    }
}
